import { FormControl, FormHelperText, InputLabel, NativeSelect as MuiNativeSelect, NativeSelectProps } from '@mui/material';
import { useEffect, useId, useRef } from 'react';
import { Option } from '../FilterPanel/types';

type Props = Omit<NativeSelectProps, 'onChange' | 'error' | 'inputRef'> & {
  label: string;
  options: Option[];
  onChange: (value: string) => void;
  error?: string;
};

/**
 * To allow better UX on mobile devices, we tend to use NativeSelect which falls back to default device behaviour.
 */
export const NativeSelect = (props: Props) => {
  const { id: idProp, label, options, onChange, variant = 'standard', error, autoFocus, ...rest } = props;
  const inputRef = useRef<HTMLSelectElement | null>(null);

  const defaultId = useId();
  const id = idProp ?? defaultId;

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <FormControl fullWidth error={!!error} sx={{ select: { wordBreak: 'break-all', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } }}>
      <InputLabel variant={variant} htmlFor={id}>
        {label}
      </InputLabel>
      <MuiNativeSelect id={id} onChange={(e) => onChange(e.target.value)} inputRef={inputRef} {...rest}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </MuiNativeSelect>
      {error && <FormHelperText sx={{ ml: 0 }}>{error}</FormHelperText>}
    </FormControl>
  );
};
